import "../ScrollBarStyle.css";

import podcastIcon from "@assets/images/Podcast.svg";
import videoIcon from "@assets/images/YouTube.svg";
import MediaThumbnail from "@components/Layouts/HomePageStoryPackages/MediaPackages/MediaThumbnail";
import MoreLink from "@components/Layouts/HomePageStoryPackages/MoreLink";
import { Heading } from "@sphtech/sph-web-ui/elements/Heading";
import { MoreLinkProps } from "@typings/StoryPackage.d";
import { twMerge } from "tailwind-merge";

interface ThumbnailItem {
  published_at?: string;
  name?: string;
  thumbnail?: string;
  src?: string;
  id?: string;
}
export type MediaCardProps<T> = {
  variant: "Podcasts" | "Videos";
  renderedThumbnail?: (T & ThumbnailItem)[];
  handleOnClickCallback: (source?: string) => void;
  moreLink: MoreLinkProps;
};

export default function MediaCard<T>({
  variant,
  renderedThumbnail,
  handleOnClickCallback,
  moreLink,
}: MediaCardProps<T>) {
  const thumbnailItems = Array.isArray(renderedThumbnail)
    ? renderedThumbnail
    : [];

  return (
    <div className="my-sm py-xs border border-brand-primary border-x-0 border-b-0 border-t-2">
      <div className="flex items-center gap-xs font-primary text-sm font-bold text-brand-primary leading-[24px] mb-xs pl-xxs">
        <img
          src={variant === "Podcasts" ? podcastIcon : videoIcon}
          alt="media-icon"
          width={20}
          height={20}
        />
        <Heading className="font-primary">{variant}</Heading>
      </div>

      <div className="overflow-x-scroll scrollBarStyles pb-md">
        <div className="flex gap-[10px] w-[2150px]">
          {thumbnailItems.map((item, index) => (
            <button
              className="flex flex-col gap-sm text-left basis-[17%] break-words overflow-auto"
              key={index}
              onClick={() => {
                handleOnClickCallback(item.src ? item.src : item.id);
              }}
            >
              <MediaThumbnail
                src={item.thumbnail}
                height={variant === "Videos" ? 155 : 206}
              />
              <div className="flex flex-col gap-sm">
                {item.name && (
                  <Heading className="lg:text-sm font-semibold font-secondary text-text-body leading-[19.2px] hover:text-brand-primary">
                    {item.name}
                  </Heading>
                )}
                {item.published_at && (
                  <span className="text-xs text-text-muted">
                    {item.published_at}
                  </span>
                )}
              </div>
            </button>
          ))}
        </div>
      </div>

      <div className="flex justify-end leading-[18px] text-neutral-700 font-bold font-primary border-border-strong border-t-[1px] pt-xs">
        <MoreLink
          {...moreLink}
          className={twMerge("flex gap-1", moreLink.className)}
        />
      </div>
    </div>
  );
}
